import { useStoreCustom } from "@/store";
type Toggle={
    toggleBar:()=>void
    toggleDark:()=>void
    responseToggle:()=>void
}

export default () : Toggle=> {
    const store = useStoreCustom();

    const toggleBar = () => {
        try {
          const sidebar = document.querySelector(".sidebar");
          const main = document.querySelector("main");
          sidebar?.classList.toggle("close");
          main?.classList.toggle("close");
        } catch (error) {
          console.error(error);
        }
      };
      const toggleDark = () => {
        const body = document.querySelector("body");
        const sidebar = document.querySelector(".sidebar");
        const navLink = document.querySelectorAll(".sidebar .nav-link");
        const toggleBar = document.querySelector(".toggle-bar");
        const toggleOn = document.querySelector(".toggle-on");
        const toggleOff = document.querySelector(".toggle-off");
        const objetoBranco = document.querySelectorAll(".bg-stf-white");
        const objetoPreto = document.querySelectorAll(".bg-stf-black");
        const toggleTexto = document.querySelector(".toggle-mode__descricao");
        body?.classList.toggle("dark");
  
        sidebar?.classList.toggle("bg-light");
        sidebar?.classList.toggle("bg-dark");
        for (const value of navLink.values()) {
          value.classList.toggle("link-dark");
          value.classList.toggle("text-white");
        }
        for (const value of objetoBranco.values()) {
          value.classList.toggle("bg-stf-white");
          value.classList.toggle("bg-stf-black");
        }
        for (const value of objetoPreto.values()) {
          value.classList.toggle("bg-stf-black");
          value.classList.toggle("bg-stf-white");
        }
        toggleOn?.classList.toggle("dark");
        toggleOff?.classList.toggle("dark");
        toggleBar?.classList.toggle("dark");
        toggleTexto?.classList.toggle("dark");
        let result = "";
        if (toggleTexto?.classList.contains("dark")) {
          result = 'Modo claro'
        } else {
          result = 'Modo escuro'
        }
        if (toggleTexto) {
          toggleTexto.innerHTML = result;
        }
      };
      const responseToggle = () => {
        const sidebar = document.querySelector(".sidebar");
        const sidebarClosed = sidebar?.classList.contains("close");
        if (
          sidebarClosed === undefined ||
          (store.getters.normativos?.length > 0 && sidebarClosed) ||
          (store.getters.normativos?.length == 0 && !sidebarClosed)
        ) {
          toggleBar();
        }
      };
    return{
        toggleBar,
        toggleDark,
        responseToggle
    }

}